import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, X } from "lucide-react";

// Shows only while balance < 2 and not dismissed; the server re-arms it after every top-up.
export function LowCreditAlert({ w, api }) {
  const [hide, setHide] = useState(false);
  if (!w?.low_alert || hide) return null;
  const dismiss = () => { setHide(true); api.post("/credits/low-alert/dismiss").catch(() => {}); };
  return (
    <div className="flex items-start gap-3 rounded-lg border border-amber-300 bg-amber-50 p-3 text-sm text-[#5c4410]" role="status" data-testid="low-credit-alert">
      <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" />
      <p className="flex-1"><span data-testid="low-credit-message">{w.low_message}</span>{" "}<Link to="/dashboard/credits" className="font-semibold underline" data-testid="low-credit-buy-link">Buy Credits</Link></p>
      <button onClick={dismiss} aria-label="Dismiss" className="p-1 rounded hover:bg-amber-100" data-testid="low-credit-dismiss"><X className="w-4 h-4" /></button>
    </div>);
}

export function LowCreditAlertLoader({ api, enabled }) {
  const [w, setW] = useState(null);
  useEffect(() => { if (enabled) { api.get("/credits/wallet").then((r) => setW(r.data)).catch(() => {}); } }, [api, enabled]);
  return <LowCreditAlert w={w} api={api} />;
}
